import { PlanetTypeGroup } from '@apeiron/planet'
import { FetchJsonProps, useReactQueryFetchJson } from '@apeiron/temp'
import ENV_CONFIG from '@src/config'

const useFetchPlanetTypeGroupJson = (props?: FetchJsonProps) => {
  const { fetchNow } = props || {}

  return useReactQueryFetchJson<PlanetTypeGroup[]>({
    fetchNow,
    path: ENV_CONFIG.JSON_FILE_NAME.PLANET_TYPE_GROUPS,
    deserialize: response => response
  })
}

export default useFetchPlanetTypeGroupJson
